<template>
  <div class="pa-park-search-request-button-field">
    <div
      class="caption-top"
      :class="captionAdditionalClass"
    >ー&nbsp;全{{parkCount}}カ所から探索致します&nbsp;ー</div>

    <button
      class="button search-request-button"
      :class="additionalClass"
      :disabled="isDisabled"
      @click.prevent="handleClick"
    >ひろばの探索をリクエストする</button>
    
    <transition name="pa-simple-fade">
      <div class="toast-wrapper" v-if="isVisibleToast">
        <div class="toast">リクエストは３日に１回行えます。</div>
      </div>
    </transition>
  </div>
</template>

<script>
import {GetCharacterCouldRequestParkSearch} from '@/graphql/queries/Character.graphql'

import {RequestParkSearch} from '@/graphql/mutations/Character.graphql'

export default {
  data(){
    return {
      isLoading       : false,
      
      isDisabled      : true,

      additionalClass : {
        'is-loading'  : false
      },

      captionAdditionalClass  : {
        'caption-top-disabled'  : true
      },

      isVisibleToast  : true,

      couldRequest    : false,

      parkCount       : 0,
    };
  },

  apollo : {
    characterCouldRequestParkSearch : {
      query: GetCharacterCouldRequestParkSearch
    }
  },

  watch : {
    isLoading(value){
      if(value === true && this.isDisabled === false){
        this.additionalClass['is-loading'] = true;
        this.isDisabled = true;
      }else if(value === true && this.isDisabled === true){
        this.additionalClass['is-loading'] = true;
      }else if(value === false && this.isDisabled === true){
        this.additionalClass['is-loading'] = false;
        this.isVisibleToast = true;
        this.captionAdditionalClass['caption-top-disabled'] = true;
      }else{
        this.additionalClass['is-loading'] = false;
      }
    },

    isDisabled(value){
      if(value === true && this.isLoading === false){
        this.isVisibleToast = true;
        this.captionAdditionalClass['caption-top-disabled'] = true;
      }else{
        this.isVisibleToast = false;
        this.captionAdditionalClass['caption-top-disabled'] = false;
      }
    },

    couldRequest(value){
      if(value === true){
        this.isDisabled = false;
      }else{
        this.isDisabled = true;
      }
    },

    characterCouldRequestParkSearch : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.couldRequest = data.result; 
        this.parkCount    = data.parkCount;
      },
      deep:true
    }
  },
  
  methods : {
    executeRequestParkSearch(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : RequestParkSearch,
          update    : (store, {data: {RequestParkSearch}}) => {
            const readData = store.readQuery({
              query : GetCharacterCouldRequestParkSearch,
            });

            readData.characterCouldRequestParkSearch = RequestParkSearch.characterCouldRequestParkSearchResult;

            store.writeQuery({
              query : GetCharacterCouldRequestParkSearch,
              data  : readData
            });
          }
        }).then(async ({data: {RequestParkSearch}}) => {
          resolve(RequestParkSearch);
        }).catch(async (error) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(error);

          if(typeof simpleErrorSet.firstError.field !== 'undefined'){
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;'+simpleErrorSet.firstError.message,
              status      : 'error',
              hasControl  : true,
              autoClose   : 3000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    async handleClick(){
      this.isLoading = true;

      await this.UXWaiting(1000);

      const result = await this.executeRequestParkSearch();

      if(result.result === true){
        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;ひろばの探索リクエストを承りました。探索完了までお楽しみにお待ちください。',
          status      : 'default',
          hasControl  : true,
          autoClose   : 4000
        }, {root:true});
      }

      this.isLoading = false;
    }
  }
}
</script>

<style lang="scss">
.pa-park-search-request-button-field{
  margin:1rem 0 2.4rem;
  text-align: center;
  position: relative;
  
  .caption-top{
    font-size:.7rem;
    width:15rem;
    margin:0 auto .2rem;
    color:#796246;

    &-disabled{
      opacity:.5;
    }
  }

  .search-request-button{
    border:0;
    font-size:1rem;
    padding:.2rem;
    width:16rem;
    border-radius: 6px;
    background-color: #BF9E75;
    color: #866C4D;
    line-height: 1;
    height:2rem;

    &.is-loading{
      opacity:.8;
    }

    &.is-loading::after{
      border: 1.3px solid #866C4D;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
  
  .toast-wrapper{
    position:absolute;
    bottom:-26px;
    width:100%;

    .toast{
      border-radius: 8px;
      margin:0 auto 0;
      padding:2px 0;
      width:13rem;
      font-size:.7rem;
      background-color: #9e7c53;
      color: #cab090;
    }
  }
}
</style>